import { Injectable } from '@angular/core';
import { UsersService } from '../backend/common/services/users.service';
import { getStorageObject, saveStorageObject } from './storage.service';

declare const ga: any;

@Injectable()
export class LasFilterStorageService {
    constructor( private _userService: UsersService) {
    }
    public async getLastFilterByKey(pageKey: string, typeFilter: any) {
        const key = await this.buildFilterKey(pageKey);
        const val = getStorageObject(key);
        return (val && new typeFilter(val)) || new typeFilter();
    }

    public async upsertFilterToKey(pageKey: string, filter: any) {
        let tempFilter = { ...filter };
        delete tempFilter.skip;
        delete tempFilter.take;
        const key = await this.buildFilterKey(pageKey);
        saveStorageObject(key, tempFilter);
    }

    private async buildFilterKey(pageKey: string): Promise<string> {
        const user = await this._userService.getCurrentUser().toPromise();
        return `${user.Id}|${pageKey}|filter`;
    }
}

